import React from "react";
import { Input, Header, Message } from "semantic-ui-react";

// Digit-only field with the OTP's letter prefix pinned to its left as a fixed,
// non-editable label, so the admin can check it against the code in their email.
//
// Not built on FormsInputsText: that spreads {...field} straight into <Input>
// with no label affix and no sanitising.
const FormsInputsOtp = ({ field, form, ...props }) => {
  const { touched, errors, setFieldValue } = form;
  const hasError = errors[field.name] && touched[field.name] ? true : false;
  return (
    <div className="form-input-group">
      <div>
        <Header sub>{props.label}</Header>
        {props.secondaryLabel ? (
          <Header.Subheader>{props.secondaryLabel}</Header.Subheader>
        ) : (
          ""
        )}
      </div>
      <Input
        fluid
        label={props.prefix}
        labelPosition="left"
        autoFocus
        autoComplete="one-time-code"
        maxLength={4}
        placeholder="0000"
        // semantic-ui-react 0.84 only forwards a known set of attributes to the
        // real <input>; inputMode is not one of them, so it goes through the
        // input shorthand instead.
        input={{ inputMode: "numeric", pattern: "[0-9]*" }}
        name={field.name}
        value={field.value}
        onBlur={field.onBlur}
        onChange={(event, data) =>
          // Also covers pasting: "ABCD-1234", "ABCD1234" and "1234" all reduce
          // to "1234", so no separate paste handler is needed.
          setFieldValue(
            field.name,
            (data.value || "").replace(/\D/g, "").slice(0, 4)
          )
        }
        disabled={props.disabled ? props.disabled : false}
      />
      {hasError && <Message negative>{errors[field.name]}</Message>}
    </div>
  );
};

export default FormsInputsOtp;
